import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'ze-login-fail',
  standalone: false,
  templateUrl: './login-fail.component.html',
  styleUrl: './login-fail.component.css',
})
export class LoginFailComponent {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  public readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  logout() {
    this.oidcSecurityService.logoff().subscribe((res) => {
      this.router.navigateByUrl('/');
    });
  }
}
